import { ReactNode } from "react";

import BacklogIcon from "@atlaskit/icon/glyph/backlog";
import BillingIcon from "@atlaskit/icon/glyph/billing";
import BoardIcon from "@atlaskit/icon/glyph/board";
import BookIcon from "@atlaskit/icon/glyph/book";
import CameraTakePictureIcon from "@atlaskit/icon/glyph/camera-take-picture";
import CheckCircle from "@atlaskit/icon/glyph/check-circle";
import CheckCircleOutlineIcon from "@atlaskit/icon/glyph/check-circle-outline";
import CommentIcon from "@atlaskit/icon/glyph/comment";
import DecisionIcon from "@atlaskit/icon/glyph/decision";
import DepartmentIcon from "@atlaskit/icon/glyph/department";
import DocumentIcon from "@atlaskit/icon/glyph/document";
import DocumentFilled from "@atlaskit/icon/glyph/document-filled";
import DocumentsIcon from "@atlaskit/icon/glyph/documents";
import EditIcon from "@atlaskit/icon/glyph/edit";
import EmojiIcon from "@atlaskit/icon/glyph/emoji";
import ErrorIcon from "@atlaskit/icon/glyph/error";
import FeedbackIcon from "@atlaskit/icon/glyph/feedback";
import FolderIcon from "@atlaskit/icon/glyph/folder";
import InviteTeamIcon from "@atlaskit/icon/glyph/invite-team";
import IssueIcon from "@atlaskit/icon/glyph/issue";
import LightbulbFilledIcon from "@atlaskit/icon/glyph/lightbulb-filled";
import ListIcon from "@atlaskit/icon/glyph/list";
import PeopleIcon from "@atlaskit/icon/glyph/people";
import PortfolioIcon from "@atlaskit/icon/glyph/portfolio";
import Refreshicon from "@atlaskit/icon/glyph/refresh";
import Roadmapicon from "@atlaskit/icon/glyph/roadmap";
import SearchIcon from "@atlaskit/icon/glyph/search";
import SettingsIcon from "@atlaskit/icon/glyph/settings";
import SprintIcon from "@atlaskit/icon/glyph/sprint";
import StatusIcon from "@atlaskit/icon/glyph/status";
import SubtaskIcon from "@atlaskit/icon/glyph/subtask";
import TeamsIcon from "@atlaskit/icon/glyph/teams";
import WatchIcon from "@atlaskit/icon/glyph/watch";
import WorldIcon from "@atlaskit/icon/glyph/world";

type IconMap = {
    [key: string]: ReactNode;
};

const featureIconMap: IconMap = {
    "analysis": <WatchIcon label="" />,
    "automation": <SettingsIcon label="" />,
    "business updates": <Refreshicon label="" />,
    "communication": <CommentIcon label="" />,
    "company wiki": <DocumentsIcon label="" />,
    "content management": <DocumentIcon label="" />,
    "decision tracking": <DecisionIcon label="" />,
    "deployment strategy": <LightbulbFilledIcon label="" />,
    "documentation": <DocumentFilled label="" />,
    "feedback": <FeedbackIcon label="" />,
    "forms": <BillingIcon label="" />,
    "goal setting": <CameraTakePictureIcon label="" />,
    "goal tracking": <CheckCircle label="" />,
    "ideation": <EmojiIcon label="" />,
    "intranet": <WorldIcon label="" />,
    "knowledge base": <BookIcon label="" />,
    "marketing research": <SearchIcon label="" />,
    "note taking": <EditIcon label="" />,
    "onboarding": <InviteTeamIcon label="" />,
    "operations": <DepartmentIcon label="" />,
    "prioritization": <BacklogIcon label="" />,
    "problem solving": <CheckCircleOutlineIcon label="" />,
    "progress tracking": <StatusIcon label="" />,
    "project management": <PortfolioIcon label="" />,
    "reporting": <FolderIcon label="" />,
    "requirements": <ListIcon label="" />,
    "resource": <BookIcon label="" />,
    "retrospective": <BoardIcon label="" />,
    "risk assessment": <ErrorIcon label="" />,
    "roadmaps": <Roadmapicon label="" />,
    "stakeholder alignment": <PeopleIcon label="" />,
    "task planning": <IssueIcon label="" />,
    "task tracking": <SubtaskIcon label="" />,
    "team alignment": <TeamsIcon label="" />,
    "team collaboration": <TeamsIcon label="" />,
    "workflows": <SprintIcon label="" />
};

// will only work for english
export const getIcon = (feature: string) => {
    return featureIconMap[feature.toLowerCase()] ?? <CheckCircle label="" />;
};
